import { NgModule } from '@angular/core';
import { OptionModule } from '../abstract/option.module';
import { OptionAfterschoolComponent } from './option-afterschool.component';
import { DndModule } from 'ngx-drag-drop';
import { AfterschoolComposeModule } from './modals/afterschool-compose/afterschool-compose.module';

@NgModule({
  imports: [
    OptionModule,
    DndModule,
    AfterschoolComposeModule,
  ],
  declarations: [OptionAfterschoolComponent],
  exports:[OptionAfterschoolComponent],
})
export class OptionAfterschoolModule { }
